export default __webpack_public_path__ + "maps-examples-inset-map-1200-059e897b4c8922f2a872fb07bef54b4f.webp";